import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
// @mui
import { Button, Container, Stack, Typography } from "@mui/material";
// components
import Iconify from "../components/iconify";
// mock
// import FileManager from "../sections/@dashboard/files/FileManager";
import { setDialog } from "../features/dialog/dialogSlice";
import FileDataTable from "../sections/@dashboard/files/FileDataTable/FileDataTable";
import { useGetFileDatasQuery } from "../features/fileData/fileDataApiSlice";
import Loading from "../components/spinners/Loading";
import ReadingConfirmationOverview from "../sections/@dashboard/files/ReadingConfirmation/ReadingConfirmationOverview";
import { NavLink, Route, Routes, useLocation } from "react-router-dom";
import PreviewDocumentView from "../sections/@dashboard/files/PreviewDocumentView";
import useAuth from "../hooks/useAuth";
import CreateNewDocumentView from "../sections/@dashboard/files/CreateNewDocumentView";
import UploadDocumentView from "../sections/@dashboard/files/UploadDocumentView";
import CreateQMStructure from "../sections/@dashboard/files/CreateQMStructure";
import FolderView from "../sections/@dashboard/files/FolderView/FolderView";

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function FilesPage() {
  const { isAdmin, isSuperAdmin } = useAuth();
  let location = useLocation();
  const { data: fileDatas, isLoading } = useGetFileDatasQuery();

  const dispatch = useDispatch();

  const handleOpenDeleteQMStructureDialog = () => {
    dispatch(
      setDialog({
        title: "QM Dokumentenstruktur löschen",
        type: "DELETE",
        content: "DeleteQMFolderStructure",
      })
    );
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title> Digit QM | QM Dokumente </title>
      </Helmet>

      <Container sx={{ minHeight: "100%" }} maxWidth="">
        {location?.pathname !== "/dashboard/files" ? (
          <Button
            component={NavLink}
            to={"/dashboard/files"}
            // onClick={() => handleChangeMenuState("/dashboard/files")}
            variant="contained"
            color="warning"
            sx={{ minWidth: 300, mb: 2 }}
            startIcon={<Iconify icon="mdi:arrow-left" />}
          >
            MENÜ
          </Button>
        ) : (
          <Typography variant="h4" gutterBottom>
            QM-Dokumente
          </Typography>
        )}

        <Routes>
          <Route
            index
            element={
              <FilesMainMenu
                isAdmin={isAdmin}
                isSuperAdmin={isSuperAdmin}
                handleOpenDeleteQMStructureDialog={
                  handleOpenDeleteQMStructureDialog
                }
              />
            }
          />
          <Route
            path="overview/:searchId"
            element={
              <>
                {fileDatas ? (
                  <FileDataTable fileDatas={fileDatas} />
                ) : (
                  <h1>Noch keine Dokumenteneinträge</h1>
                )}
              </>
            }
          />

          <Route path="folderview" element={<FolderView />} />

          {isAdmin && (
            <Route path="reading" element={<ReadingConfirmationOverview />} />
          )}
          {isSuperAdmin && (
            <Route path="create-qm" element={<CreateQMStructure />} />
          )}
          <Route path="show/:fileId" element={<PreviewDocumentView />} />
          <Route path="new" element={<CreateNewDocumentView />} />
          <Route path="upload" element={<UploadDocumentView />} />
        </Routes>
      </Container>
    </>
  );
}

function FilesMainMenu({
  isAdmin,
  isSuperAdmin,
  handleOpenDeleteQMStructureDialog,
}) {
  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="space-between"
      sx={{ minHeight: "100%", py: 3 }}
    >
      <Button
        component={NavLink}
        to={"overview/show"}
        variant="contained"
        sx={{ minWidth: 300, my: 3 }}
        startIcon={<Iconify icon="gala:menu-left" />}
      >
        Dokumentenübersicht
      </Button>
      <Button
        component={NavLink}
        to={"folderview"}
        variant="contained"
        sx={{ minWidth: 300, my: 3 }}
        startIcon={<Iconify icon="mdi:folders-outline" />}
      >
        Ordneransicht
      </Button>
      <Button
        component={NavLink}
        to={"new"}
        variant="contained"
        sx={{ minWidth: 300, my: 3 }}
        startIcon={<Iconify icon="mdi:file-document-plus-outline" />}
      >
        Neues Dokument
      </Button>
      <Button
        component={NavLink}
        to={"upload"}
        variant="contained"
        sx={{ minWidth: 300, my: 3 }}
        startIcon={<Iconify icon="grommet-icons:document-upload" />}
      >
        Dokument hochladen
      </Button>
      {isAdmin && (
        <Button
          component={NavLink}
          to={"reading"}
          variant="contained"
          sx={{ minWidth: 300, my: 3 }}
          startIcon={<Iconify icon="mdi:book-check-outline" />}
        >
          Lesebestätigungen
        </Button>
      )}
      {isSuperAdmin && (
        <>
          <Button
            component={NavLink}
            to={"create-qm"}
            variant="contained"
            sx={{ minWidth: 300, my: 3 }}
            startIcon={<Iconify icon="lets-icons:folders-line" />}
          >
            QM Struktur erstellen
          </Button>

          <Button
            onClick={handleOpenDeleteQMStructureDialog}
            color="error"
            sx={{ minWidth: 300, my: 3 }}
            variant="contained"
            startIcon={<Iconify icon="tabler:folders-off" />}
          >
            ORDNERSTRUKTUR LÖSCHEN
          </Button>
        </>
      )}
    </Stack>
  );
}
